<!--begin::Notifications-->
<div ngbDropdown placement="bottom-right" autoClose="outside" class="dropdown dropdown-fluid">
    <!--begin::Toggle-->
    <div ngbDropdownToggle class="topbar-item">
        <ng-container *ngIf="useSVG">
            <div class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1" [ngClass]="{'pulse pulse-primary': (pulsing$ | async)}">
                <span class="svg-icon svg-icon-xl svg-icon-primary" [inlineSVG]="icon"></span>
                <span class="pulse-ring"></span>
                <span class="badge badge-pill badge-danger mad-badge-notify" [hidden]="(cnt | async )== 0">{{cnt | async}}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="!useSVG">
            <i [ngClass]="icon"></i>
        </ng-container>
    </div>
    <!--end::Toggle-->

    <!--begin::Dropdown-->
    <div ngbDropdownMenu class="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg" style="width: 400px;">
        <form>
            <!--begin::Header-->
            <div class="d-flex flex-column pt-10 bp-10 bgi-size-cover bgi-no-repeat rounded-top"
                 [ngStyle]="{'background-image': backGroundStyle()}"
            style="height: 120px;">
                <!--begin::Title-->
                <h4 class="d-flex flex-center rounded-top">
                    <span class="text-white">User Notifications</span>
                    <span class="btn btn-text btn-success btn-sm font-weight-bold btn-font-md ml-2"
                          (click)="removeAll()" [hidden]="(entitySubject | async  ).length == 0">Clear All
					</span>
                </h4>
            </div>
            <!--end::Header-->

            <ngb-tabset #tab="ngbTabset" class="tab-content">
                <ngb-tab id="tab-id-1" class="tab-pane">
                    <ng-template ngbTabContent>
                        <div class="p-8">
                            <div class="pr-7 mr-n7 scroll" [perfectScrollbar]="{wheelPropagation: false}"
                                 [ngStyle]="{'max-height': '300px', 'position': 'relative'}">
                                <div class="d-flex align-items-center justify-content-between mb-6"
                                     *ngFor="let item of (entitySubject| async)">
                                    <div class="d-flex align-items-center">
                                        <div class="symbol symbol-40 symbol-light-primary mr-5">
                                            <span class="symbol-label">
                                                <i class="flaticon-edit kt-font-primary"></i>
                                                <!-- <i *ngIf="[1, 4].indexOf(item.type) >= 0" class="flaticon2-add kt-font-success"></i>
                                                <i *ngIf="[1, 4, 10, 11, 12, 21, 22, 23, 24, 25, 26, 27, 28, 29, 31, 32, 33, 35, 36].indexOf(item.type) < 0"
                                                class="flaticon-users-1 kt-font-warning"></i>
                                                <i *ngIf="[21, 22, 23].indexOf(item.type) >= 0" class="flaticon-upload kt-font-primary"></i>
                                                <i *ngIf="[31, 32].indexOf(item.type) >= 0" class="flaticon2-information kt-font-info"></i>
                                                <i *ngIf="[10].indexOf(item.type) >= 0" class="flaticon-edit kt-font-primary"></i>
                                                <i *ngIf="[35, 36].indexOf(item.type) >= 0" class="flaticon-reply kt-font-info"></i>
                                                <i *ngIf="[11, 12, 24, 25, 26, 27, 28, 29, 33].indexOf(item.type) >= 0" class="flaticon-delete-1 kt-font-danger"></i> -->
                                            </span>
                                        </div>
                                            <ng-container [ngSwitch]="item.type">
                                                <ng-container *ngSwitchCase="1">
                                                    <ng-container *ngTemplateOutlet="proposalCreated; context: {notification: item}"></ng-container>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="2">
                                                    <ng-container *ngTemplateOutlet="readyToBeSent; context: {notification: item}"></ng-container>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="3">
                                                    <ng-container *ngTemplateOutlet="readyToBeReviewed; context: {notification: item}"></ng-container>
                                                </ng-container>
                                                <ng-container *ngSwitchDefault>
                                                    <div class="d-flex flex-column font-weight-bold">
                                                        <a (click)="goToLink(item)" class="text-dark text-hover-primary mb-1 font-size-lg" style="cursor: pointer;">
                                                            {{item.title}}
                                                        </a>
                                                        <span class="text-muted">
                                                            {{item.created_at | dateAgo}}
                                                        </span>
                                                    </div>
                                                </ng-container>
                                            </ng-container>
                                    </div>
                                    <span class="float-right cursor-pointer" (click)="removeOne(item.id)" matTooltip="Remove notification">
                                        <i class="flaticon2-trash kt-font-hover-dark"></i>
                                    </span>
                                </div>

                                <div class="d-flex flex-center text-center text-muted"
                                     *ngIf="!(entitySubject|async).length"
                                     style="min-height: 200px;">
                                    You have no notifications at the moment.
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-tab>
            </ngb-tabset>
        </form>
    </div>
    <!--end::Dropdown-->
</div>
<!--end::Notifications-->

<ng-template #proposalCreated let-notification="notification">
    <div class="d-flex flex-column font-weight-bold">
        <a (click)="goToLink(notification)" class="text-dark text-hover-primary mb-1" style="cursor: pointer">
            <div>
                {{ notification.title }}
            </div>
            <div class="d-flex flex-column">
                <ul class="ml-0" style="padding-left: 1rem;">
                    <li>{{notification.additional_info.proposal_ref}}</li>
                    <ng-container *ngIf="notification.additional_info.properties.length == 1">
                        <li>{{notification.additional_info.properties[0].ref}}</li>
                        <li>{{notification.additional_info.properties[0].address}}</li>
                    </ng-container>
                    <ng-container *ngIf="notification.additional_info.properties.length != 1">
                        <li>{{notification.additional_info.properties.length}} Target properties</li>
                    </ng-container>
                    <li>Due on the {{notification.additional_info.completion_date|date:'dd MMM, yyyy'}}</li>
                </ul>
            </div>
        </a>
        <span class="text-muted">
            {{notification.created_at | dateAgo}}
        </span>
    </div>
</ng-template>

<ng-template #readyToBeSent let-notification="notification">
    <div class="d-flex flex-column font-weight-bold">
        <a (click)="goToLink(notification)" class="text-dark text-hover-primary mb-1" style="cursor: pointer">
            <div>
                {{ notification.title }}
            </div>
            <div class="d-flex flex-column">
                <ul class="ml-0" style="padding-left: 1rem;">
                    <li>{{notification.additional_info.proposal_ref}}</li>
                    <li>{{notification.additional_info.valuation_ref}}</li>
                    <li>{{notification.additional_info.address}}</li>
                    <ng-container *ngIf="notification.additional_info.lead_valuer">
                        <li>{{notification.additional_info.lead_valuer}}</li>
                    </ng-container>
                    <li>Due on the {{notification.additional_info.completion_date|date:'dd MMM, yyyy'}}</li>
                </ul>
            </div>
        </a>
        <span class="text-muted">
            {{notification.created_at | dateAgo}}
        </span>
    </div>
</ng-template>

<ng-template #readyToBeReviewed let-notification="notification">
    <div class="d-flex flex-column font-weight-bold">
        <a (click)="goToLink(notification)" class="text-dark text-hover-primary mb-1" style="cursor: pointer">
            <div>
                {{ notification.title }}
            </div>
            <div class="d-flex flex-column">
                <ul class="ml-0" style="padding-left: 1rem;">
                    <li>{{notification.additional_info.proposal_ref}}</li>
                    <li>{{notification.additional_info.valuation_ref}}</li>
                    <li>{{notification.additional_info.address}}</li>
                    <ng-container *ngIf="notification.additional_info.lead_valuer">
                        <li>{{notification.additional_info.lead_valuer}}</li>
                    </ng-container>
                    <li>Due on the {{notification.additional_info.completion_date|date:'dd MMM, yyyy'}}</li>
                </ul>
            </div>
        </a>
        <span class="text-muted">
            {{notification.created_at | dateAgo}}
        </span>
    </div>
</ng-template>